import DapDSCallout from './callout.component'

export * from './callout.component'
export default DapDSCallout

DapDSCallout.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-callout': DapDSCallout
  }
}
